(() => {
  if (window.__citrusLazyComponentLoaderInitialized) return;
  window.__citrusLazyComponentLoaderInitialized = true;

  const loadedScripts = new Map();

  function hydrateImages(root) {
    root.querySelectorAll('[data-lazy-src]').forEach(image => {
      if (image.dataset.lazySrcset) {
        image.srcset = image.dataset.lazySrcset;
      }
      image.src = image.dataset.lazySrc;
      image.removeAttribute('data-lazy-src');
      image.removeAttribute('data-lazy-srcset');
    });
  }

  function loadScript(src) {
    if (loadedScripts.has(src)) return loadedScripts.get(src);

    const existing = document.querySelector(`script[src="${CSS.escape(src)}"]`);
    if (existing) {
      const ready = Promise.resolve();
      loadedScripts.set(src, ready);
      return ready;
    }

    const ready = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    loadedScripts.set(src, ready);
    return ready;
  }

  function activate(component) {
    if (!component || component.dataset.lazyComponentActivated === 'true') return;
    component.dataset.lazyComponentActivated = 'true';
    hydrateImages(component);
    loadScript(component.dataset.lazyComponentSrc).catch(() => {
      component.dataset.lazyComponentActivated = 'false';
    });
  }

  function observe(root = document) {
    const components = root.querySelectorAll('[data-lazy-component-src]:not([data-lazy-component-observed])');
    if (!components.length) return;

    if (!('IntersectionObserver' in window)) {
      components.forEach(activate);
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          activate(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });

    components.forEach(component => {
      component.dataset.lazyComponentObserved = 'true';
      observer.observe(component);
      component.addEventListener('pointerdown', () => activate(component), { once: true, passive: true });
      component.addEventListener('focusin', () => activate(component), { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe());
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
